// The ids that are both ticked AND on screen. A search hides rows without unticking them; what the
// person can see is what they are acting on, so a hidden, still-ticked row is never part of a batch.
export function visibleSelectedIds(rows, selected) {
  return rows.filter((row) => selected.has(row.id)).map((row) => row.id);
}
